import React, { useState, useEffect } from 'react';
import { Link, Stack, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Toaster } from '../../@dashboard/attributes';
import { useLoginMutation } from '../../../services/dvagent';
import { setUserToken } from '../../../features/authSlice';
import { getToken, storeToken, getSession, removeSession, storeRefresh, setLastActivity } from '../../../services/LocalStorageService';
import Iconify from '../../../components/iconify';

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [serverError, setServerError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [login] = useLoginMutation();
  const dispatch = useDispatch();
  const isButtonDisabled = !username || !password;
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleForgot = () => {
    navigate('/cloud/forgot-password', { replace: true });
  };

  const handlesetUsername = (event) => {
    setServerError("")
    setUsername(event.target.value);
  };

  const handleSetPassword = (event) => {
    setServerError("")
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); 
    setIsLoading(true);
    const actualData = {
      username,
      password
    };
    const res = await login(actualData);
    setIsLoading(false);

    if (res.error) {
      setServerError(res.error.data);
    }
    if (res.data) {
      showToast(true, '✔', 'Login successful! Redirecting...');
      storeToken(res.data.access_token);
      storeRefresh(res.data.refresh_token);
      setLastActivity(Date.now());
      dispatch(setUserToken({ token: getToken() }));
      navigate('/');
    }
  };

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 10000); 
  };

  useEffect(() => {
    if(getSession()){
      showToast(false, '⚠', 'Session expired. Please login again.');
      removeSession()
    }
  })

  return (
    <form onSubmit={handleSubmit}>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      {serverError ? (
        <Typography variant="body2" sx={{ mb: 3, color: "#C70039" }}>
          {serverError.msg}
        </Typography>
      ) : ( 
        serverError === undefined ? (
          <Typography variant="body2" sx={{ mb: 3, color: "#C70039"}}>
            Something went wrong, please try again.
          </Typography>
        ) : (
          <Typography variant="body2" sx={{ mb: 3 }}>
            Enter your credentials
          </Typography>
        )
      )}
      <Stack spacing={3}>
        <TextField
          name="username" 
          label="Username or Email" 
          value={username} 
          onChange={handlesetUsername}
          autoComplete="off"
        />
        <TextField
          autoComplete="off"
          name="password"
          label="Password"
          value={password}
          onChange={handleSetPassword}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <Link variant="subtitle2" underline="hover" sx={{ color: 'text.secondary', cursor: 'pointer' }} onClick={handleForgot}>
          Forgot password?
        </Link>
      </Stack>
      <LoadingButton 
        fullWidth 
        size="large" 
        disabled={isButtonDisabled}  
        loading={isLoading} 
        sx={{ bgcolor: '#A8A196', ":hover": {bgcolor: "#7D7463"}}} 
        type="submit" 
        variant="contained"
      >
        Login
      </LoadingButton>
    </form>
  );
}
